// Angular
import { Injectable } from '@angular/core';

// Third party
import { Observable } from 'rxjs';

// Local library
import {
  IAvailableReplayVideosResponse,
  IGetRCNReplayVideoLinkRequest,
  IGetRCNReplayVideosByFiltersRequest,
  IRCNGetLinkResponse
} from '@amwager/util-ts';

// Local file
import { HttpService } from '../services';



// TODO: write tests
@Injectable()
export class VideoStreamingAPIService {
  private readonly API_URL = '/api/VideoStreaming';

  constructor(
    private readonly httpService: HttpService,
  ) {}


  /**
   * GET API
   */

  /**
   * @description
   * Get a device specific live video streaming link.
   *
   * @param toteEventId string
   * @returns Observable<IRCNGetLinkResponse>
   */
  getIGBLiveVideoLink$(toteEventId: string): Observable<IRCNGetLinkResponse> {
    return this.httpService.get$({
      api: `${this.API_URL}/GetIGBLiveVideoLink`,
      params: this.httpService.objToHttpParams({
        toteEventId
      })
    });
  }

  /**
   * @description
   * Get a device specific live video streaming link.
   *
   * @param toteEventId string
   * @param width number
   * @param height number
   * @returns Observable<IRCNGetLinkResponse>
   */
  getRCNLiveVideoLinkH2L$(toteEventId: string, width: number, height: number)
    : Observable<IRCNGetLinkResponse> {
    return this.httpService.get$({
      api: `${this.API_URL}/GetRCNLiveVideoLinkH2L`,
      params: this.httpService.objToHttpParams({
        toteEventId,
        width,
        height
      })
    });
  }

  /**
   * @description
   * Get a device specific live video streaming link.
   *
   * @param toteEventId string
   * @param width number
   * @param height number
   * @returns Observable<IRCNGetLinkResponse>
   */
  getRCNLiveVideoLink$(toteEventId: string, width: number, height: number)
    : Observable<IRCNGetLinkResponse> {
    return this.httpService.get$({
      api: `${this.API_URL}/GetRCNLiveVideoLink`,
      params: this.httpService.objToHttpParams({
        toteEventId,
        width,
        height
      })
    });
  }

  /**
   * @description
   * Get a device specific replay video streaming link.
   *
   * @param requests IGetRCNReplayVideoLinkRequest
   * @returns Observable<IRCNGetLinkResponse>
   */
  getRCNReplayVideoLinkH2L$(requests: IGetRCNReplayVideoLinkRequest)
    : Observable<IRCNGetLinkResponse> {
    return this.httpService.get$({
      api: `${this.API_URL}/GetRCNReplayVideoLinkH2L`,
      params: this.httpService.objToHttpParams(requests as Record<string, unknown>)
    });
  }

  /**
   * @description
   * Get a device specific replay video streaming link.
   *
   * @param requests IGetRCNReplayVideoLinkRequest
   * @returns Observable<IRCNGetLinkResponse>
   */
  getRCNReplayVideoLink$(requests: IGetRCNReplayVideoLinkRequest)
    : Observable<IRCNGetLinkResponse> {
    return this.httpService.get$({
      api: `${this.API_URL}/GetRCNReplayVideoLink`,
      params: this.httpService.objToHttpParams(requests as unknown as Record<string, unknown>)
    });
  }

  /**
   * @description
   * Get available replay video streaming links based on filters.
   * Notes: Track type can be : 0 = All, 1 = Quarterhorse, 2 = Greyhound,
   * 3 = Harness, 4 = Thoroughbred
   *
   * @param requests IGetRCNReplayVideosByFiltersRequest
   * @returns Observable<IAvailableReplayVideosResponse>
   */
  getRCNReplayVideosByFilters$(requests: IGetRCNReplayVideosByFiltersRequest)
    : Observable<IAvailableReplayVideosResponse> {
    return this.httpService.get$({
      api: `${this.API_URL}/GetRCNReplayVideosByFilters`,
      params: this.httpService.objToHttpParams(requests as Record<string, unknown>)
    });
  }

}
